import { render, staticRenderFns } from "./SocialBoxChartExample.vue?vue&type=template&id=981e66a8&"
import script from "./SocialBoxChartExample.vue?vue&type=script&lang=js&"
export * from "./SocialBoxChartExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports